'use client';

import { c as _c } from "react/compiler-runtime";
import { useEffect } from 'react';
import Modal from 'react-modal';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faXmark } from '@awesome.me/kit-94e593bf23/icons/sharp/light';

/**
 * VideoModal - Dedicated playback surface for product videos.
 *
 * Decouples movie playback from the image-slideshow UX. Opens from:
 * - Video thumb click in the thumb carousel
 * - Video slide click in the main carousel
 * - Same triggers inside ProductCarouselModal
 *
 * Iframe is conditionally rendered, so closing the modal unmounts it and
 * stops playback.
 */
const VideoModal = t0 => {
  const $ = _c(21);
  const {
    video,
    productName,
    isOpen,
    setIsOpen
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = [];
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  useEffect(_temp, t1);
  let t2;
  if ($[1] !== setIsOpen) {
    t2 = () => {
      setIsOpen(false);
    };
    $[1] = setIsOpen;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  const closeModal = t2;
  let t3;
  if ($[3] !== video) {
    t3 = () => {
      if (!video) {
        return null;
      }
      if (video.platform === "vimeo") {
        return `https://player.vimeo.com/video/${video.videoId}?autoplay=1&muted=0&playsinline=1&loop=0&title=0&byline=0&portrait=0`;
      }
      if (video.platform === "youtube") {
        return `https://www.youtube-nocookie.com/embed/${video.videoId}?autoplay=1&mute=0&playsinline=1&rel=0`;
      }
      return null;
    };
    $[3] = video;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  const getEmbedUrl = t3;
  const embedUrl = getEmbedUrl();
  const t4 = productName ? `${productName} video` : "Product video";
  let t5;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <FontAwesomeIcon icon={faXmark} className="text-lg" />;
    $[5] = t5;
  } else {
    t5 = $[5];
  }
  let t6;
  if ($[6] !== closeModal) {
    t6 = <button type="button" onClick={closeModal} className="absolute -top-4 -right-4 w-8 h-8 flex items-center justify-center bg-white rounded-full shadow-lg text-dark hover:text-primary transition-colors z-10" aria-label="Close">{t5}</button>;
    $[6] = closeModal;
    $[7] = t6;
  } else {
    t6 = $[7];
  }
  let t7;
  if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = {
      aspectRatio: "16 / 9"
    };
    $[8] = t7;
  } else {
    t7 = $[8];
  }
  let t8;
  if ($[9] !== embedUrl || $[10] !== isOpen || $[11] !== productName) {
    t8 = isOpen && embedUrl && <iframe src={embedUrl} className="absolute inset-0 w-full h-full" frameBorder="0" allow="autoplay; fullscreen; picture-in-picture" allowFullScreen={true} title={productName ? `${productName} video` : "Product video"} />;
    $[9] = embedUrl;
    $[10] = isOpen;
    $[11] = productName;
    $[12] = t8;
  } else {
    t8 = $[12];
  }
  let t9;
  if ($[13] !== t8) {
    t9 = <div className="relative w-full" style={t7}>{t8}</div>;
    $[13] = t8;
    $[14] = t9;
  } else {
    t9 = $[14];
  }
  let t10;
  if ($[15] !== closeModal || $[16] !== isOpen || $[17] !== t4 || $[18] !== t6 || $[19] !== t9) {
    t10 = <Modal overlayClassName="fixed inset-0 z-[1200] flex items-center justify-center bg-modal-overlay" className="relative bg-black rounded-sm w-full max-w-[1100px] mx-4 outline-none" isOpen={isOpen} onRequestClose={closeModal} contentLabel={t4}>{t6}{t9}</Modal>;
    $[15] = closeModal;
    $[16] = isOpen;
    $[17] = t4;
    $[18] = t6;
    $[19] = t9;
    $[20] = t10;
  } else {
    t10 = $[20];
  }
  return t10;
};
export default VideoModal;
function _temp() {
  Modal.setAppElement("#hivenext");
}